module.exports = __webpack_public_path__ + "media/bootstrap-icons/lightning-b07c371f.svg";